﻿
import React from 'react';

export const HeadingAndText = (props) => {
  const wrappingClass = 'single-step__section single-step__section--info';

  return (
    <div className={wrappingClass}>
      <label className="single-step__section__label">{props.heading}</label>
      {props.children}
      <p>{props.text}</p>
    </div>
  )
}
